import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  props: {
    username: null,
    id: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$router.push(`/user/${__props.id}`)), ["stop"])),
    class: "cursor-hover underline-hover"
  }, _toDisplayString(__props.username), 1))
}
}

})